var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MINUS_svg__cls-1",
    d: "M512 224.35v63.29H0v-63.29z"
  })));
};
export { SvgMinus as ReactComponent };
export default "data:image/svg+xml,%3csvg id='Layer_1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e %3cdefs%3e %3c/defs%3e %3crect class='cls-1' x='224.35' y='0' width='63.29' height='512' transform='translate(512 0) rotate(90)'/%3e %3c/svg%3e";